import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Zap, Target, Shield, Users } from "lucide-react";

const advantages = [
  {
    icon: <Zap className="w-8 h-8 text-primary" />,
    title: "Save Time & Money",
    description:
      "No more juggling multiple vendors. Get everything you need in one place with integrated workflows and expert guidance.",
  },
  {
    icon: <Target className="w-8 h-8 text-primary" />,
    title: "Stay Focused on Growth",
    description:
      "Let us handle the complex compliance, paperwork, and administrative tasks so you can focus on what matters most.",
  },
  {
    icon: <Shield className="w-8 h-8 text-primary" />,
    title: "Reduce Risk",
    description:
      "Stay compliant and protected with expert guidance, automated processes, and built-in best practices.",
  },
  {
    icon: <Users className="w-8 h-8 text-primary" />,
    title: "Access Expert Network",
    description:
      "Connect with trusted professionals - accountants, attorneys, HR specialists, and advisors - all vetted and ready to help.",
  },
];

const BizServePortalAdvantages = () => {
  return (
    <section className="py-16 px-4 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            How BizServe Helps You Succeed
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Our all-in-one platform eliminates the complexity of business
            management, giving you more time to focus on what you do best.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {advantages.map((advantage, index) => (
            <Card
              key={index}
              className="text-center border hover:shadow-lg transition-shadow"
            >
              <CardHeader>
                <div className="mx-auto mb-4">{advantage.icon}</div>
                <CardTitle className="text-xl">{advantage.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">{advantage.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BizServePortalAdvantages;
